<div class="flex flex-col bg-pet-gray-2 w-auto md:w-[400px] rounded-lg py-1 pb-10 px-5">
  <h2 mat-dialog-title>{{data.tittle}}</h2>
<mat-dialog-content class="w-full">
  <div class="text-pet-color-text-1 font-semibold text-center">
    {{data.message}}
  </div>  

</mat-dialog-content>
<mat-dialog-actions class="flex gap-3">
  <button class="flex-1 bg-red-500 w-full text-white font-semibold py-2 px-5 hover:bg-red-300 rounded" mat-dialog-close>Cancelar</button>
  <button class="flex-1 bg-green-500 w-full text-white font-semibold py-2 px-5 hover:bg-green-300 rounded" [mat-dialog-close]="true" cdkFocusInitial>Confirmar</button>
</mat-dialog-actions>

</div>